<template>
  <ThreeCT
    :top-title="mgnlPropsWithBtnColors.topTitle"
    :top-title-color="mgnlPropsWithBtnColors.topTitleColor"
    :sub-text="mgnlPropsWithBtnColors.subText"
    :sub-text-color="mgnlPropsWithBtnColors.subTextColor"
    :slides="mgnlPropsWithBtnColors.slides"
    :image-load-type="(mgnlPropsWithBtnColors.imageLoadType as ('eager' | 'lazy'))"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { ThreeCTBuilder, WrapperProps } from './ThreeCT.model';
import ThreeCT from './ThreeCT.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = ThreeCTBuilder.build(props);

magnoliaGetters.migratePageLinkToCtaLink(mgnlProps);

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  topTitleColor: magnoliaGetters.getHexColor(mgnlProps.topTitleColor),
  subTextColor: magnoliaGetters.getHexColor(mgnlProps.subTextColor),
  slides: mgnlProps.slides?.map(slide => ({
    ...slide,
    ctaTextColor: slide.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(slide.ctaLink?.[0]?.ctaTextColor) : '#3c3c3b',
    mobileAspectRatio: slide.mobileAspectRatio?.[0]?.aspectRatio,
  })),
};
</script>
